import { Asterisk } from "./icons";

const WORDS = [
  "Insumos especiales",
  "Fondant y coberturas",
  "Boquillas de precisión",
  "Herramientas de modelado",
  "Moldes y capacillos",
  "Accesorios y empaques",
  "Asesoría local en tienda",
  "Envíos a todo Ecuador",
];

export default function Marquee() {
  return (
    <section className="marquee-band relative -rotate-1 scale-[1.02] overflow-hidden bg-rose py-4 shadow-[0_20px_50px_-30px_rgba(217,72,104,0.6)] sm:py-5" aria-label="Especialidades de la tienda">
      <div className="marquee-track">
        {[0, 1].map((copy) => (
          <div
            key={copy}
            aria-hidden={copy === 1}
            className="flex shrink-0 items-center"
          >
            {WORDS.map((w) => (
              <span key={`${copy}-${w}`} className="flex items-center">
                <span className="whitespace-nowrap px-6 font-display text-2xl font-medium italic text-cream sm:text-3xl">
                  {w}
                </span>
                <Asterisk className="h-6 w-6 shrink-0 text-gold" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
